        $(document).ready(function() {

          setTimeout(function(){
            $('.subify-powered-text').remove();
          },1000);
          
          setTimeout(function(){
            $('.subify-powered-text').remove();
          },2000);

           setTimeout(function(){
            $('.subify-powered-text').remove();
          },4000);
          
            $('.need-high').each(function() {
                var html = $(this).html().trim();
                var lastSpaceIndex = html.lastIndexOf(' ');
                if (lastSpaceIndex !== -1) {
                    var newHtml = html.substring(0, lastSpaceIndex) + ' <span class="highlight">' + html.substring(lastSpaceIndex + 1) + '</span>';
                    $(this).html(newHtml);
                }
            });

        });


        $(document).ready(function() {
            var newText = '<span class="start-from">Starting at </span>';
            $(".price ins .amount").each(function() {
                $(this).html(newText + $(this).html());
            });
        });

      if (window.location.pathname === "/collections/all") {
          window.onload = function() {
            document.title = "SHOP";
          };
       }else if(window.location.pathname === "/policies/shipping-policy"){
          window.onload = function() {
            document.title = "SHIPPING AND RETURNS";
          };
       }

      $(document).ready(function() {
          if (window.location.pathname === "/collections/all") {
              // $(".custom-header .row h1").text("Our Products");
              $(".custom-header .row h1").text("SHOP");
              
              $('.custom-header .row').append(`<div style="width: 100%;display: flex;justify-content: space-around;"> <p> Click on products below to find out more about each DOSE. If you aren't sure where to start, learn more about the <a
                      href="https://dosemyhair.myshopify.com/blogs/types-of-hair-loss" target="_blank"> types of hair loss </a> we
                  treat. <br/>Once you’re ready to find the right DOSE for your hair concern, start
                  your free <a href="https://quiz.dosemyhair.com/" target="_blank"> online consultation </a> for our expert
                  recommendations.
              </p> </div>`);
          }else if(window.location.pathname === "/policies/shipping-policy"){
              $(".shopify-policy__title h1").text("SHIPPING AND RETURNS");
          }
      });

      let bloodTestUrl = window.location.href;

      let bloodTestProductName = bloodTestUrl.split('/').pop().split('?')[0];
        
      if(bloodTestProductName == 'blood-test-kit'){
           
          bloodTestProduct($('select.js-product-option-input[data-name="option1"]').val());

          bloodTestTooltip($('select.js-product-option-input[data-name="option2"]').val());
         
      }

     $('select.js-product-option-input[data-name="option2"]').on('change', function() {
        let url = window.location.href;

        let productName = url.split('/').pop().split('?')[0];
        
        if(productName == 'blood-test-kit'){
           bloodTestTooltip($(this).val());
        }
     });
       
      function bloodTestTooltip(value){

        let tooltip = '';
        if(value == 'Nurse home visit £59'){

           tooltip = `<span>A qualified nurse will visit your home for a convenient sample blood collection.</span>`;
          
        }else if(value == 'Visiting a partner clinic £35'){

           tooltip = `<span>Book an appointment at a Medichecks trusted partner clinic for an in-person blood sample collection. </br><a href="https://www.medichecks.com/pages/clinic-finder" target="_blank"> Click here </a> to find your nearest clinic.
            	</span>`;
          
        }else if(value == 'AT-HOME FINGER PRICK TEST (FREE)'){

            tooltip = `<span>Easily collect your blood sample from the comfort of your home using our simple finger prick test kit.</span>`;
           
        }

        if($('.bloodTestTooltip').length == 0){
          let newTooltip = `<div class="bloodTestTooltip"> <img src="https://cdn.shopify.com/s/files/1/0831/6564/3098/files/213219.png?v=1743417071" style="width: 17px;margin-left: 5px;height: 17px;">${tooltip}</div>`; 
          $('.variations .product-form__input').eq(1).find('.form__label').append(newTooltip);
        }else{
           let newTooltip = `<img src="https://cdn.shopify.com/s/files/1/0831/6564/3098/files/213219.png?v=1743417071" style="width: 17px;margin-left: 5px;height: 17px;"> ${tooltip}`;
           $('.bloodTestTooltip').html(newTooltip);
        }
         
        
      }
     

      function bloodTestProduct(value){
            
            if(value == 'Blood test - General Hair Loss'){
      
                $('.tab-content.details').html(`
      		<p>Take control of your hair health with this powerful, all-in-one test that tests key nutritional, thyroid hormone,
      			and mineral biomarkers that could be affecting your hair. Whether you're dealing with thinning, shedding, or
      			just unsure what could be contributing to your hair loss, this test is a great starting point.</p>
      		<p><b>Important:</b> This test requires an intravenous blood draw (a sample taken from a vein in the arm - options and
      			details below) by a nurse at home or at a Medichecks clinic. Once you’ve purchased the test, you'll receive
      			clear step-by-step instructions via email to guide you through the process.</p>
      		<p><b>Suited to </b></p>
      		<p>If you aren't sure what the cause or your hair loss might be and don't know where to start, then this is the
      			ultimate first step.</p>
      		<p><b>Full test details :- <b></p>
      		<p>This comprehensive at-home test will assess the biomarkers below:</p>
      		<ul>
      			<li>haemoglobin</li>
      			<li>MCHC</li>
      			<li>monocytes</li>
      			<li>urea</li>
      			<li>globulin</li>
      			<li>HDL cholesterol</li>
      			<li>LDL cholesterol</li>
      			<li>non HDL cholesterol</li>
      			<li>triglycerides-ferritin</li>
      			<li>total T3-free T3</li>
      			<li>haematocrit</li>
      			<li>RDW</li>
      			<li>eosinophils</li>
      			<li>creatinine</li>
      			<li>ALT</li>
      			<li>glucose (random)</li>
      			<li>red cell count</li>
      			<li>white cell count-basophils</li>
      			<li>eGFR-GGT</li>
      			<li>free thyroxine</li>
      			<li>total thyroxine</li>
      			<li>zinc</li>
      			<li>vitamin B12</li>
      			<li>MCV</li>
      			<li>neutrophils</li>
      			<li>platelet count</li>
      			<li>sodium-total protein</li>
      			<li>CRP HS</li>
      			<li>vitamin D</li>
      			<li>MCH</li>
      			<li>lymphocytes</li>
      			<li>MPV</li>
      			<li>bilirubin</li>
      			<li>albumin</li>
      			<li>uric acid</li>
      			<li>TSH</li>
      			<li>folic acid</li>
      			<li> erythrocytes</li>
      		</ul>`);

            $('.tab-content.how-it-works').html(`
            	<p>Once you purchase this test, you’ll be emailed instructions on the next steps. </p>
            	<p>Because this test is so comprehensive it needs a good amount of blood. You can either book a nurse home visit
            		(admin costs are £59 for this service, to collect the sample via intravenous draw) or visit your nearest
            		Medichecks partner clinic (admin costs are £35). <a href="https://clinics.medichecks.io/?page=1"
            			target="_blank">Click here</a> to find your nearest Medichecks partner clinic.</p>
            	<p>If you pick a nurse home visit, a kit will be sent to the delivery address specified in the order, and a
            		Medichecks partner provider will contact you via your provided contact number within 48 hours to schedule a
            		convenient appointment.</p>
            	<p>If you choose to visit a Medichecks partner clinic for a venous blood draw, a sample collection kit will be sent
            		to you, along with details of your nearest clinic location based on the postcode provided. An email will follow
            		with instructions on how to book your appointment.</p>`);
              
            $('.tab-content.how-to-use').html(`
            	<p>Once you’ve had your blood taken, Medichecks will notify you when your blood sample has been received in the lab.
            		You will then receive an email within 7-10 days telling you that your results and report are in your DOSE
            		customer portal. Just log in and access the information, which will include the results, findings and suggested
            		actions where applicable.</p>`);  
              
            }else if(value == 'Blood test – Sex Hormones (male)'){
      
              $('.tab-content.details').html(`
        		<p>This at-home test kit offers a powerful snapshot of the key male sex hormones that influence your overall
        			well-being and hair health. Imbalances in these hormones can play a major role in hair loss, thinning, or
        			slower growth, as they directly affect the hair follicles. Understanding your hormone levels can help you
        			take control and boost your hair health from the inside out.</p>
        		<p>This comprehensive at-home test will assess the biomarkers below:</p>
        		<ul>
        			<li>adrenal hormones (DHEA sulphate)</li>
        			<li>free androgen index</li>
        			<li>free testosterone </li>
        			<li>LH</li>
        			<li>FSH</li>
        			<li>oestradiol</li>
        			<li>prolactin</li>
        			<li>testosterone</li>
        			<li>proteins (albumin and SHBG)</li>
        		</ul>
        		<p><b>Suited to</b></p>
        		<p>Men. If you were assigned a different gender at birth, our hormone profile tests may not be suitable depending on whether you are taking any hormone therapy. We would recommend taking the comprehensive test to investigate hair loss more generally and to discuss with your healthcare provider regarding hormone tests which may be suitable. Please <a href="/pages/advice-for-transgender" target="_blank">  click here </a> for more information on what might be the best DOSE treatment for you.</p>
                `);

              
            	$('.tab-content.how-it-works').html(`
            	<p>Purchase the test and decide if you’d like to submit your blood work via an at-home finger prick test, or via an
            		intravenous blood draw (a sample taken from a vein in the arm - options and details below). After your blood
            		work is submitted, Medichecks will notify you when your blood sample has been received in the lab. You will then
            		receive an email within 5-7 days telling you that your results and report are in your DOSE customer portal. Just
            		log in and access the information, which will include the results, findings and suggested actions where
            		applicable.</p>
            
            	<p> <b>At-home finger prick test kits - </b> if you choose this option your kit will be sent to the address provided, and
            		once you’ve followed the instructions included, just return it to the address given via post. There is no
            		additional fee for this service.</p>
            
            	<p> <b> Visit a Medichecks partner clinic - </b> you can visit a Medichecks partner clinic to have your sample taken via
            		an intravenous blood draw. If you choose this option a sample collection kit will be sent to you, along with
            		details of your nearest clinic location based on the postcode provided. An email will follow with instructions
            		on how to book your appointment. The admin costs are £35 for this service.</p>
            	<p> <b> Nurse home visit - </b> you can choose to book a nurse home visit to collect the sample via an intravenous blood draw.
            		If you pick a nurse home visit, a kit will be sent to the delivery address specified in the order, and a
            		Medichecks partner provider will contact you via your provided contact number within 48 hours to schedule a
            		convenient appointment. The admin costs are £59 for this service.</p>`);

              $('.tab-content.how-to-use').html(`
              	<p>Take your sample between 6am and 10am. Avoid vigorous exercise or sexual activity for 48 hours beforehand – both
              		can raise your prolactin level. Avoid nipple stimulation or heavy meals before taking the test, as these can
              		increase prolactin levels. Avoid taking a finger-prick sample from a finger used to handle hormone gels in the
              		past 4 weeks. Use gloves when applying these. Do not take biotin supplements for two days before this test,
              		discuss this with your doctor if it is prescribed.</p>`);
              
            }else if(value == 'Blood test – Sex Hormones (female)'){
      
               $('.tab-content.details').html(`
            		<p>This at-home test kit provides an in-depth look at the female sex hormones that play a vital role in your
            			overall well-being and hair health. Imbalances in these hormones, such as estrogen and progesterone, can
            			contribute to hair thinning or loss, especially during key life stages like pregnancy, menopause, or
            			hormonal shifts. Understanding your hormone levels can empower you to take charge of your hair health and
            			overall vitality.</p>
            		<p>This comprehensive at-home test will assess the below bio markers:</p>
            		<ul>
            			<li>free androgen index</li>
            			<li>FSH</li>
            			<li>hormone phase</li>
            			<li>LH</li>
            			<li>oestradiol</li>
            			<li>prolactin</li>
            			<li>testosterone</li>
            			<li>proteins (SHBG)</li>
            			<li>thyroid hormones (TSH and free thyroxine)</li>
            		</ul>
            		<p><b>Suited to </b></p>
                    <p>Women. If you were assigned a different gender at birth, our hormone profile tests may not be suitable depending on whether you are taking any hormone therapy. We would recommend taking the comprehensive test to investigate hair loss more generally and to discuss with your healthcare provider regarding hormone tests which may be suitable. Please <a href="/pages/advice-for-transgender" target="_blank">  click here </a> for more information on what might be the best DOSE treatment for you.</p>
            		
              `);

              $('.tab-content.how-it-works').html(`
            	<p>Purchase the test and decide if you’d like to submit your blood work via an at-home finger prick test, or via an
            		intravenous blood draw (a sample taken from a vein in the arm - more details below). After your blood work is
            		submitted, Medichecks will notify you when your blood sample has been received in the lab. You will then receive
            		an email within 5-7 days telling you that your results and report are in your DOSE customer portal. Just log in
            		and access the information, which will include the results, findings and suggested actions where applicable.</p>
            	<p> <b>At-home finger prick test kits - </b> if you choose this option your kit will be sent to the address provided, and
            		once you’ve followed the instructions included, just return it to the address given via post. There is no
            		additional fee for this service.</p>
            	<p> <b>Visit a Medichecks partner clinic - </b> you can visit a Medichecks partner clinic to have your sample taken via
            		an intravenous blood draw. If you choose this option a sample collection kit will be sent to you, along with
            		details of your nearest clinic location based on the postcode provided. An email will follow with instructions
            		on how to book your appointment. The admin costs are £35 for this service.</p>
            	<p> <b> Nurse home visit - </b> you can choose to book a nurse home visit to collect the sample via an intravenous blood draw.
            		If you pick a nurse home visit, a kit will be sent to the delivery address specified in the order, and a
            		Medichecks partner provider will contact you via your provided contact number within 48 hours to schedule a
            		convenient appointment. The admin costs are £59 for this service.</p>`);

               $('.tab-content.how-to-use').html(`
            	<p>If you are premenopausal take your test between days 2 and 5 of your menstrual cycle, or ideally day 3. If you're
            		postmenopausal, you can take your test at any time.</p>
            	<p>In either case, it's important to keep a log of the date of your last period, and any other information regarding
            		your periods or menopause status to hand. If you don't let us know the date of your last period, Medichecks will
            		interpret your result as though you took your test on day 3.</p>`);
              
            }else if(value == 'Blood test - Thyroid'){
                 $('.tab-content.details').html(`
            		<p>This at-home test kit gives you an all-in-one look at your thyroid hormones, which are crucial for your
            			overall well-being and hair health. Imbalances in thyroid hormones can lead to unexpected hair loss,
            			thinning, or slow growth, as they directly impact the health of your hair follicles. Understanding your
            			thyroid levels empowers you to take control and support your hair health by gaining insights into your exact
            			thyroid profile.</p>
            		<p>This comprehensive at-home test will assess the biomarkers below:</p>
            		<ul>
            			<li>thyroglobulin antibodies</li>
            			<li>thyroid peroxidase antibodies</li>
            			<li>free T3</li>
            			<li>free thyroxine</li>
            			<li>TSH</li>
            		</ul>
            		<p><b>Suited to</b></p>
            		<p>All genders</p>`);


              $('.tab-content.how-it-works').html(`
            	<p>Purchase the test and decide if you’d like to submit your blood work via an at-home finger prick test, or via an
            		intravenous blood draw (a sample taken from a vein in the arm - more details below). After your blood work is
            		submitted, Medichecks will notify you when your blood sample has been received in the lab. You will then receive
            		an email within 5-7 days telling you that your results and report are in your DOSE customer portal. Just log in
            		and access the information, which will include the results, findings and suggested actions where applicable.</p>
            	<p> <b> At-home finger prick test kits - </b> if you choose this option your kit will be sent to the address provided, and
            		once you’ve followed the instructions included, just return it to the address given via post. There is no
            		additional fee for this service.</p>
            	<p> <b> Visit a Medichecks partner clinic - </b> you can visit a Medichecks partner clinic to have your sample taken via
            		an intravenous blood draw. If you choose this option a sample collection kit will be sent to you, along with
            		details of your nearest clinic location based on the postcode provided. An email will follow with instructions
            		on how to book your appointment. The admin costs are £35 for this service.</p>
            	<p><b> Nurse home visit - </b> you can choose to book a nurse home visit to collect the sample via an intravenous blood draw.
            		If you pick a nurse home visit, a kit will be sent to the delivery address specified in the order, and a
            		Medichecks partner provider will contact you via your provided contact number within 48 hours to schedule a
            		convenient appointment. The admin costs are £59 for this service.</p>`);

               $('.tab-content.how-to-use').html(`
                	<p>Take your sample between 6am and 10am. Take your sample at least 24 hours after any vitamin or mineral
                		supplements. Do not take biotin supplements for two days before this test, discuss this with your doctor if it
                		is prescribed. If you take thyroxine, you can take your medication as usual, either before or after your blood
                		test. However, if you take desiccated thyroid extract (DTE) or liothyronine, it's best to take it after you've
                		collected your sample. Please let us know in your supporting information if you take amiodarone or lithium as
                		these can affect your thyroid function results.</p>
                	<p></p>`);
              
            }
       }

     
      $('select.js-product-option-input[data-name="option1"]').on('change', function() {

        let url = window.location.href;

        let productName = url.split('/').pop().split('?')[0];
        
         if(productName == 'blood-test-kit'){
           bloodTestProduct($(this).val());
         }

            
      });